import { createRouter, createWebHistory } from 'vue-router';

function generateRoutes(requireContext){
    const routes = [];

    requireContext.keys().forEach(fileName => {
        // 제외 폴더
        if (fileName.includes('/common/') || fileName.includes('/modals/') || fileName.includes('/main/')) {
            return;
        }

        const component = requireContext(fileName).default;

        // 파일 경로를 URL 경로로 변환
        let path = fileName
            .replace(/^\.\//, '') // 시작 부분의 ./ 제거
            .replace(/\.(vue|js)$/, '') // 확장자 제거
            .replace(/\/index$/, '') // index는 제거
            .toLowerCase(); // 소문자로 변환

        // 동적 라우트 처리
        path = path.replace(/\[([^\]]+)\]/g, ':$1');
        path = path.replace(/_([^/]+)/g, ':$1');

        // 경로가 비어있으면 루트 경로
        if (!path || path === '') {
            path = '/';
        } else if (!path.startsWith('/')) {
            path = '/' + path;
        }

        // 라우트 이름 생성 (경로에서 특수문자 제거)
        const name = path
                .replace(/[/:]/g, '-')
                .replace(/^-+|-+$/g, '') // 시작과 끝의 - 제거
                .replace(/-+/g, '-') // 연속된 -를 하나로
            || 'home';

        // 메타데이터 추출 (컴포넌트에 정의되어 있다면)
        const meta = component.meta || {};

        routes.push({
            path,
            name,
            component,
            meta: {
                ...meta,
                // 파일 경로 정보 추가 (디버깅용)
                __filePath: fileName
            }
        });
    });

    // 경로 길이 기준으로 정렬 (더 구체적인 경로가 먼저 오도록)
    routes.sort((a, b) => {
        // 동적 라우트는 뒤로
        const aDynamic = a.path.includes(':');
        const bDynamic = b.path.includes(':');

        if (aDynamic && !bDynamic) return 1;
        if (!aDynamic && bDynamic) return -1;

        // 경로 깊이로 정렬
        const aDepth = a.path.split('/').length;
        const bDepth = b.path.split('/').length;

        return bDepth - aDepth;
    });

    return routes;
}

export function setupAutoRoutes() {
    // webpack의 require.context 사용
    const requireComponent = require.context(
        '@/components', // 검색할 폴더
        true, // 하위 폴더도 검색
        /\.(vue|js)$/ // .vue 또는 .js 파일
    );

    const routes = generateRoutes(requireComponent);

    // 다른 컴포넌트 추가
    routes.push(
        {
            path: '/',
            name: 'Login',
            component: () => import('@/components/common/Login.vue')
        },{
            path: '/main',
            name: 'Main',
            component: () => import('@/components/main/Main.vue')
        },{
            path: '/FindID',
            name: 'FindID',
            component: () => import('@/components/common/FindID.vue')
        },{
            path: '/FindPassword',
            name: 'FindPassword',
            component: () => import('@/components/common/FindPassword.vue')
        },{
            path: '/register',
            name: 'Register',
            component: () => import('@/components/common/Register.vue')
        },{
            path: '/management',
            name: 'Management',
            component: () => import('@/components/account/Management.vue')
        },{
            path: '/HospitalCodeManagement',
            name: 'HospitalCodeManagement',
            component: () => import('@/components/account/HospitalCodeManagement.vue')
        },
        {
            path: '/deviceDetails',
            name: 'DeviceDetails',
            component: () => import('@/components/system/DeviceDetails.vue')
        },

    );

    return routes;
}

const routes = setupAutoRoutes();

const router = createRouter({
    history: createWebHistory( process.env.BASE_URL),
    routes,
    scrollBehavior() {
        return { top: 0 };
    }
});

export default router;
